import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldGet from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet.js";
import _classPrivateFieldSet from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classPrivateFieldSet.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";
function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
/**
 *  Events allow for applications to use the observer pattern, which
 *  allows subscribing and publishing events, outside the normal
 *  execution paths.
 *
 *  @_section api/utils/events:Events  [about-events]
 */
import { defineProperties } from "./properties.js";
/**
 *  When an [[EventEmitterable]] triggers a [[Listener]], the
 *  callback always ahas one additional argument passed, which is
 *  an **EventPayload**.
 */
var _listener = /*#__PURE__*/new WeakMap();
export var EventPayload = /*#__PURE__*/function () {
  /**
   *  The event filter.
   */

  /**
   *  The **EventEmitterable**.
   */

  /**
   *  Create a new **EventPayload** for %%emitter%% with
   *  the %%listener%% and for %%filter%%.
   */
  function EventPayload(emitter, listener, filter) {
    _classCallCheck(this, EventPayload);
    _defineProperty(this, "filter", void 0);
    _defineProperty(this, "emitter", void 0);
    _classPrivateFieldInitSpec(this, _listener, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldSet(this, _listener, listener);
    defineProperties(this, {
      emitter: emitter,
      filter: filter
    });
  }
  /**
   *  Unregister the triggered listener for future events.
   */
  _createClass(EventPayload, [{
    key: "removeListener",
    value: function () {
      var _removeListener = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(_classPrivateFieldGet(this, _listener) == null)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              _context.next = 4;
              return this.emitter.off(this.filter, _classPrivateFieldGet(this, _listener));
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function removeListener() {
        return _removeListener.apply(this, arguments);
      }
      return removeListener;
    }()
  }]);
  return EventPayload;
}();